import { api } from "api/api";
import { AxiosError } from "axios";
import DefeitoFabricacao from "model/meta/producao/DefeitoFabricacao";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta, DataTableOperatorFilterMetaData } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class DefeitoFabricacaoService implements BaseServiceCadastros<DefeitoFabricacao> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/defeitoFabricacao/pesquisar`;
            url += getFilters(filters);

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<DefeitoFabricacao>((resolve, reject): void => {
            api
                .get(`/defeitoFabricacao/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(defeitoFabricacao: DefeitoFabricacao) {
        return new Promise<DefeitoFabricacao>((resolve, reject): void => {
            api
                .post(`/defeitoFabricacao/incluir`, JSON.stringify(defeitoFabricacao))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(defeitoFabricacao: DefeitoFabricacao) {
        return new Promise<DefeitoFabricacao>((resolve, reject): void => {
            api
                .put(`/defeitoFabricacao/editar`, JSON.stringify(defeitoFabricacao))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/defeitoFabricacao/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default DefeitoFabricacaoService;